import type * as React from 'react';
import { put } from '@Domain/Api';
import type { AiProviderPayload } from '@Application/Ai/AiConfiguration/Providers/Actions/aiProvidersFetched';
import aiProviderUpdated, {
	type AiProviderUpdatedAction,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProviderUpdated';
import aiProviderUpdateFailed, {
	type AiProviderUpdateFailedAction,
} from '@Application/Ai/AiConfiguration/Providers/Actions/aiProviderUpdateFailed';
import type UpdateAiProvider from '@Application/Ai/AiConfiguration/Providers/Commands/UpdateAiProvider';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = AiProviderUpdatedAction | AiProviderUpdateFailedAction;

export default (command: UpdateAiProvider) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<AiProviderPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/ai-providers/${command.providerId}`,
				command.toJSON(),
			);

			const action = aiProviderUpdated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiProviderUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
